import {
  SET_RECEIPT
} from 'src/store/mutation-types'

export default {
  [SET_RECEIPT] (state, receipt) {
    state.receipt = receipt
  }
}



// WEBPACK FOOTER //
// ./src/components/receipt/store/mutations.js